module.exports = __webpack_public_path__ + "img/transfer.7b013db4.png";